import {
  delay
} from 'redux-saga'
import { ENV } from 'config.js'
import {
  select,
  fork,
  put,
  all,
  call,
  takeEvery,
  cancelled,
} from 'redux-saga/effects'
import T from 'i18n-react'
import formatSize from 'helpers/FormatSize'
import {
  keysToCamelCase,
  formDataHeader,
  buildFormData,
  jwtConfig,
  get,
  postRequest
} from 'helpers/RequestUtil'
import axios from 'axios'
import { postNvbugs } from 'containers/Project/NvqualSection/sagas'
import {
  PAGE,
  CHANGE_ACTIVE,
  CHANGE_PAGE,
  DROP_REJECTED,
  POST_UPLOAD_FILE,
  MAX_SIZE,
  FILE_TYPE_STRING
} from './constants'

import {
  createNvbugs as createNvbugsAction
} from 'containers/Project/NvqualSection/actions'

import {
  resetActive,
  resetPage,
  updateActive,
  updatePage,
  setLoadingPage,
  postUploadFileStart,
  postUploadFileSuccess,
  postUploadFileError,
  clearUploadFiles,
  clearNewRevisionName
} from './actions'

import {
  isUploadingSelector,
  filesSelector,
  newRevisionNameSelector,
  createNvbugSelector
} from './selectors'
import { fetchNvqualReport } from 'containers/Project/NvqualSection/actions'
import { fetchProjectFiles } from 'containers/Project/FileSection/actions'
import { projectIdSelector } from 'containers/Project/View/selectors'

import {
  error,
  success
} from 'containers/App/Notification/actions'

import {
  post
} from 'helpers/RequestUtil'


function* reset() {
  yield put(resetActive())
  yield put(resetPage())
}

function* postUploadFile(file, revisionName){
  try {
    yield put(postUploadFileStart())
    yield put(setLoadingPage())

    const dateTime = new Date().toJSON().substring(0,19).replace(/-|:/g,'')
    
    const config = formDataHeader()
    const projectId = yield select(projectIdSelector)
    const fileData = buildFormData({
      file,
      revision_name: revisionName,
    })
    const { data } = yield call(
      axios.post,
      `/api/fulcrum/projects/${projectId}/nvqual_new`,
      fileData,
      config
    )

    if (yield cancelled()) {
      yield put(error(T.translate('pages.project.view.notification.upload_error')))
      return { success: false, error: '' }
    }

    return { success: true, revisionId: data.revision_id, name: file.name }
  } catch(err) {
    yield put(error(T.translate(
      'pages.project.view.notification.upload_error'
    )))
    return { success: false, error: err }
  }
}

function* handleChangePage(action) {
  const { page } = action
  yield put(updatePage(page))
}

function* handleChangeActive(action) {
  const { active, projectId } = action
  const isUploading = yield select(isUploadingSelector)
  if ( !isUploading ) {
    yield put(updateActive(active, projectId))
    if (!active) {
      yield fork(reset)
    }
  }
}

function* handleDropRejected(action) {
  const { files: [{ name }] } = action
  yield put(error(T.translate(
    'pages.project.view.notification.drop_rejected',
    {
      name,
      size: formatSize(MAX_SIZE),
      types: FILE_TYPE_STRING.join(',')
    }
  )))
}

function* handlePostUploadFile({createNvbug}) {
  const file = yield select(filesSelector)
  const revisionName = yield select(newRevisionNameSelector)
  const response = yield call(postUploadFile, file[0], revisionName)

  if (!response.success) {
    yield put(postUploadFileError(response.error))
    yield fork(reset)
    return
  }
  
  yield put(success(T.translate(
    'pages.project.view.notification.post_upload_success',
    { name: response.name }
  )))

  yield put(postUploadFileSuccess())

  if (createNvbug){
    yield call(postNvbugs, response.revisionId)
    // yield put (createNvbugsAction(response.revisionId))
  } 

  yield put(clearUploadFiles())
  yield put(clearNewRevisionName())

  // update project attachments
  const projectId = yield select(projectIdSelector)
  yield put(fetchProjectFiles(projectId))
  // update nvqual report section
  yield put(fetchNvqualReport())
  
  yield fork(reset)
}

function* watchChangeActive() {
  yield takeEvery(CHANGE_ACTIVE, handleChangeActive)
}

function* watchChangePage() {
  yield takeEvery(CHANGE_PAGE, handleChangePage)
}

function* watchDropRejected() {
  yield takeEvery(DROP_REJECTED, handleDropRejected)
}

function* watchPostUploadFile() {
  yield takeEvery(POST_UPLOAD_FILE, handlePostUploadFile)
}

function* loadSagas() {
  yield all([
    fork(watchChangeActive),
    fork(watchChangePage),
    fork(watchDropRejected),
    fork(watchPostUploadFile),
  ])
}

export default loadSagas
